/**
 * @prettier
 **/
export default {
	en: {
		MENU_LEFT_PINGTREE_ADD: 'Create Ring Tree',
		PING_TREE_SHOW_ALL: 'Show all Ring Trees',
		PING_TREES_HEADER_NONE: 'You have not created any Ring Trees.',
		PING_TREE_HEADER_LOADING: 'Loading Ring Tree Details',
		PING_TREES_HEADER_LOADING: 'Loading Ring Trees',
		PING_TREES_HEADER: 'Manage Ring Trees',
		PING_TREE_UPDATE_SUCCESS: 'Ring Tree Updated',
		PING_TREE_CREATE_SUCCESS: 'Ring Tree Created',
		DELETE_PING_TREE_SUCCESSFUL_MESSAGE: 'Ring Tree Deleted',
		PING_TREES_NAME: 'Name',
		PING_TREES_MIN_REVENUE_TO_ROUTE: 'Min Rev.',
		PING_TREES_REVENUE_DYNAMIC_TO_ROUTE: 'Dynamic Rev.',
		PING_TREES_REVENUE_ON_FAILURE: 'Rev. On Failure',
		PING_TREES_TARGETS: 'Targets',
		PING_TREES_STATUS: 'Status',
		PING_TREE_ID: 'Ring Tree ID',
		PING_TREE_NAME: 'Name',
		PING_TREE_NAME_TT:
			'The name used to identify this tree throughout Ringba. Shorter names are better.',
		PING_TREE_TIME_ZONE: 'Time Zone',
		PING_TREE_TIME_ZONE_TT:
			'Select the Time Zone that this tree operates in. All caps operate based on this time zone.',
		PING_TREE_SET_HOURS: 'Hours of Operation',
		PING_TREE_SET_HOURS_TT:
			"Set your tree's hours of operation. For weekly schedule use advanced settings.",
		PING_TREES_SET_HOURS_STATUS: 'Always Open',
		PING_TREE_REVENUE_SETTINGS_TITLE_TT:
			'Configure Revenue Settings of this ring tree.',
		PING_TREE_REVENUE_SETTINGS_TITLE: 'Revenue Settings',
		PING_TREE_REVENUE_MIN_TO_ROUTE_AMOUNT_TT:
			'Minimum amount of money to be accepted for the call',
		ERROR_PING_TREE_REVENUE_MIN_TO_ROUTE_AMOUNT_TT:
			'Minimum Revenue Amount must be greater than zero',
		PING_TREE_REVENUE_MIN_TO_ROUTE_AMOUNT: 'Minimum Revenue Amount',
		PING_TREE_REVENUE_TYPE_TT: 'Revenue Type of this ring tree',
		PING_TREE_REVENUE_TYPE: 'Revenue Type',
		PING_TREE_REVENUE_DYNAMIC: 'Dynamic',
		PING_TREE_REVENUE_STATIC: 'Static',
		PING_TREE_STATIC_REVENUE_AMOUNT_TT:
			'Fixed amount of money paid to you for the call',
		PING_TREE_STATIC_REVENUE_AMOUNT: 'Static Revenue Amount',
		PING_TREE_REVENUE_ON_FAILURE_AMOUNT_TT:
			'Amount of money paid to you for the call on failed ping attempts',
		ERROR_PING_TREE_REVENUE_ON_FAILURE_AMOUNT:
			'Failure Revenue Amount must be greater than zero',
		PING_TREE_REVENUE_ON_FAILURE_AMOUNT: 'Failure Revenue Amount',
		PING_TREE_CONVERT_TT:
			'A conversion will be triggered when the selected event happens.',
		PING_TREE_CONVERT: 'Convert On',
		PING_TREE_CONVERT_LENGTH: 'Call Length',
		PING_TREE_CALL_SUCCESSFULLY_CONNECTED: 'Call Successfully Connected',
		PING_TREE_CONVERT_POSTBACK: 'Postback/Webhook',
		PING_TREE_CONVERT_ON_DIALED: 'Dialed',
		PING_TREE_START_EVENT: 'Start Call Length On',
		PING_TREE_START_EVENT_TT:
			'The point in the call where we start the call length timer for the conversion.',
		PING_TREE_START_INCOMING: 'Incoming',
		PING_TREE_START_DIAL: 'Dial',
		PING_TREE_START_CONNECT: 'Connect',
		PING_TREE_TARGET_DYNAMIC_LENGTH: 'Conversion call length value',
		PING_TREE_TARGET_DYNAMIC_LENGTH_TT:
			'Source of call duration requirement for conversion, Static for pre-determined duration and Dynamic for values supplied in ping respone.',
		PING_TREE_TARGET_REVENUE_STATIC: 'Static',
		PING_TREE_TARGET_LENGTH_TT:
			'The number of seconds required before a call is counted as a conversion.',
		PING_TREE_TARGET_LENGTH: 'Length',
		PING_TREE_TARGET_DYNAMIC_MAX_LENGTH_TT:
			'The maximum accepted dynamic call duration, in seconds. If the ping response requires a higher call duration for conversion, the ping will be ignored.',
		PING_TREE_TARGET_DYNAMIC_MAX_LENGTH: 'Max dynamic duration',
		SECONDS_TEXT: 'seconds',
		PING_TREE_ERROR_SETTINGS_TITLE_TT:
			'Configure Error Settings of this ring tree.',
		PING_TREE_ERROR_SETTINGS_TITLE: 'Error Settings',
		PING_TREE_DIAL_TIMEOUT_SECONDS_TT:
			'Maximum amount of seconds to wait for dial (Min: 5 / Max: 300)',
		PING_TREE_DIAL_TIMEOUT_SECONDS: 'Dial Timeout',
		ERROR_PING_TREE_DIAL_TIMEOUT_SECONDS: `The Dial Timeout must be greater than 5 and less than 300`,
		PING_TREE_PING_TIMEOUT_MILLISECONDS_TT: 'Maximum amount of milliseconds to wait for ping response (Min: 50 / Max: 10000)',
		PING_TREE_PING_TIMEOUT_MILLISECONDS: 'Ping Timeout',
		ERROR_PING_TREE_PING_TIMEOUT_MILLISECONDS: `The Ping Timeout must be greater than 50 and less than 10000 ms`,
		MILLISECONDS_TEXT: 'milliseconds',
		PING_TREE_CALL_ON_FAILURE_TT:
			'Should the target be called even if the ping fails?',
		PING_TREE_CALL_ON_FAILURE: 'Call On Failure',
		PING_TREE_ADD_TARGETS_TITLE_TT:
			'Add targets to this tree which will be pinged when this tree recieves a call',
		PING_TREE_ADD_TARGETS_TITLE: 'Add Ring Tree Targets',
		PING_TREE_ADD_TARGETS_REQUIRED: 'You haven\'t added any Ring Tree Targets. Ring Trees require Ring Tree Targets to send calls to. If you add this Ring Tree to an active campaign, calls might drop.',
		PING_TREE_SELECT_TARGET_TT: 'Select Target to add to tree.',
		PING_TREE_SELECT_TARGET: 'Select Target',
		PING_TREE_LIST_ADD: 'Add',
		PING_TREE_LIST_NAME: 'Target',
		PING_TREE_LIST_DESTINATION: 'Destination',
		PING_TREE_DYNAMIC_TARGET_NUMBER: 'Dynamic',
		PING_TREE_LIST_DELETE_TT: 'Remove',
		PING_TREE_TARGET_DUPLICATED_WARNING:
			'This ring tree target is already associated with a RT, if you save the target will be duplicated',
		INVALID_FORM: 'Please fill out required or invalid fields and try again',
		DELETE_PING_TREE_MODAL_TARGET_CHECK_ASSOCIATION_TEXT:
			"Determining if this ring tree is currently associated with any <strong class='f-s-13'>Campaigns, Ring Tree Targets or Routing Plans.</strong>",
		DELETE_PING_TREE_MODAL_TARGET_CHECK_ASSOCIATION_ERROR_TEXT:
			'An error occurred while determining associated Campaigns, Ring Tree Targets or Routing Plans, please try again',
		PING_TREES_ACTIONS_EDIT: 'Edit',
		PING_TREES_ENABLED_FALSE: 'Enable Tree',
		PING_TREES_ENABLED_TRUE: 'Disable Tree',
		PING_TREES_ACTIONS_DELETE: 'Delete Ring Tree',
		DELETE_PING_TREE_MODAL_NONE_ASSOCIATION_TEXT:
			'The ring tree is not associated with any Campaigns, Ring Tree Targets or Routing Plans',
		DELETE_PING_TREE_MODAL_TITLE: 'Delete Ring Tree',
		DELETE_PING_TREE_MODAL_CHECKBOX:
			'Confirm to delete this Ring Tree from all Campaigns, Ring Tree Targets or Routing Plans',
		DELETE_PING_TREE_MODAL_ASSOCIATION_TEXT:
			'Are you sure you want to delete this ring tree?</br><strong>{pingTreeName}</strong> is currently associated with the following items:',
		VIEW_CAMPAIGN: 'View Campaign',
		DELETE_PING_TREE_MODAL_VIEW_TARGET: 'View Ring Tree Target',
		NO_ROUTE_SETUP_WARNING_PING_TREE:
			'No other route setup besides this ring tree',
  	PING_TREE_REVENUE_SETTINGS_WARNING_MESSAGE: 'You should set the "Revenue Type" to "Dynamic" only if the buyer includes the bid amount in the ping response. Otherwise, the bid will be rejected due to missing bid amount. Note: Calls will be converted with the bid amount the buyer sends in the Webhook rather than the amount in the ping response.'
		
	}
};
